module.exports = __webpack_public_path__ + "media/images/goals-347990394e8c055db41566867d837f9a.jpeg";